import type { CancelSource, CoachingSession } from '@efdigital/ll-addon-data';
import { displayValue } from '@efdigital/ll-admin-v2/utils/display-value';
import type { TOC } from '@ember/component/template-only';

const CANCEL_SOURCE_LABELS: Record<CancelSource, string> = {
  coachee: 'Coachee',
  coach: 'Coach',
  admin: 'Admin',
  external_calendar: 'External calendar',
};

function cancelSourceLabel(source: CancelSource): string {
  return CANCEL_SOURCE_LABELS[source];
}

<template>
  <div class="card rounded-4 border-danger" ...attributes>
    <h3 class="card-header text-danger border-danger h5 py-3">Cancellation</h3>
    <div class="card-body">
      <div class="row mb-2">
        <div class="col-sm-4 col-lg-3 text-body-secondary">
          Cancel source
        </div>
        <div class="col-sm-8 col-lg-9">
          {{#if @coachingSession.cancelSource}}
            {{cancelSourceLabel @coachingSession.cancelSource}}
          {{else}}
            —
          {{/if}}
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4 col-lg-3 text-body-secondary">
          Cancel reason
        </div>
        <div class="col-sm-8 col-lg-9">
          {{displayValue @coachingSession.cancelReason}}
        </div>
      </div>
    </div>
  </div>
</template> satisfies TOC<{
  Args: {
    coachingSession: CoachingSession;
  };
  Element: HTMLDivElement;
}>;
